export const footerNavigations = [
    {
        name: "linkedin",
        title: "Linkedin",
        type: "link",
        path: "https://www.linkedin.com/in/wasim-linked-in"
    },
    {
        name: "x",
        title: "X",
        type: "link",
        path: "https://x.com/wasim_id_"
    },
    {
        name: "instagram",
        title: "Instagram",
        type: "link",
        path: "https://www.instagram.com/_unknown_wasim_"
    },
    {
        name: "github",
        title: "Github",
        type: "link",
        path: "https://github.com/wasim963"
    }
]